var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgLinkLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1934 15.3644L16.7794 13.9484L18.1934 12.5344C19.4657 11.2731 19.966 9.4275 19.5049 7.69633C19.0437 5.96516 17.6916 4.61302 15.9604 4.15186C14.2292 3.6907 12.3836 4.19101 11.1224 5.46336L9.70836 6.87836L8.29336 5.46436L9.70936 4.05036C12.4432 1.31655 16.8755 1.31655 19.6094 4.05036C22.3432 6.78417 22.3432 11.2165 19.6094 13.9504L18.1944 15.3644H18.1934ZM15.3654 18.1924L13.9504 19.6064C11.2165 22.3402 6.78417 22.3402 4.05036 19.6064C1.31655 16.8725 1.31655 12.4402 4.05036 9.70636L5.46536 8.29236L6.87936 9.70836L5.46536 11.1224C4.19301 12.3836 3.6927 14.2292 4.15386 15.9604C4.61502 17.6916 5.96716 19.0437 7.69833 19.5049C9.4295 19.966 11.2751 19.4657 12.5364 18.1934L13.9504 16.7794L15.3654 18.1934V18.1924ZM14.6574 7.58536L16.0724 9.00036L9.00136 16.0704L7.58636 14.6564L14.6574 7.58636V7.58536Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkLine);
export default __webpack_public_path__ + "static/media/link-line.f0f1d7829b61095f36b78042b2912858.svg";
export { ForwardRef as ReactComponent };